"use client";

import type { ExpandingMenuItemProps } from "./types/expanding-menu-item.types";
import { expandingMenuItemStyles } from "./styles/expanding-menu-item.styles";

export const ExpandingMenuItem: React.FC<ExpandingMenuItemProps> = (props) => {
  const { as = "a", children, className, ...rest } = props;
  const styles = expandingMenuItemStyles({ className });

  const Component = as;

  return (
    <Component className={styles} {...rest}>
      {children}
    </Component>
  );
};

ExpandingMenuItem.displayName = "ExpandingMenuItem";
